<!-- 企业级-业务领域-配置 -->
<template>
  <div class="mainArea CAccessConfig">
    <el-button type="primary" class="mb20 mt20" @click="openAdd"
      >新建门禁预约</el-button
    >
    <div class="tabList">
      <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
        <el-table-column
          prop="id"
          label="编号"
          width="100"
        ></el-table-column>
        <el-table-column prop="audit_name" label="项目名称"></el-table-column>
        <el-table-column prop="user_name" label="审批人"></el-table-column>
        <el-table-column label="包含设备">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="getAccessDevice(scope.row.device_info)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="预约二维码">
          <template slot-scope="scope">
            <el-button type="text" @click="previewImgByIndex(scope.$index)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="openEdit(scope.$index)"
              >修改</el-button
            >
            <el-button type="text" @click="openStatus(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging" v-if="total > page">
      <el-pagination
        @current-change="CurrentChange"
        :current-page.sync="curr"
        :page-size="page"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!--新建弹窗-->
    <el-dialog
      title="新建门禁预约"
      :visible.sync="addDio"
      width="700px"
      class="configDio accessDio"
      center
    >
      <!-- <el-steps :active="addform.addStep" simple>
        <el-step title="1、编辑名称"></el-step>
        <el-step title="2、选择设备"></el-step>
        <el-step title="3、设置审批"></el-step>
      </el-steps> -->
      <div class="step">
        <div class="item" :class="{ activeStep: addform.addStep == 1 }">
          1、编辑名称
        </div>
        <div class="item" :class="{ activeStep: addform.addStep == 2 }">
          2、选择设备
        </div>
        <div class="item" :class="{ activeStep: addform.addStep == 3 }">
          3、设置审批
        </div>
      </div>
      <template v-if="addform.addStep == 1">
        <div class="contDio minH300">
          <div class="tips tc">
            <p>为新建项目命名</p>
            <p>以根据名称区别不同的门禁预约项目</p>
          </div>
          <el-input
            placeholder="请输入项目名称"
            v-model="addform.projectName"
          ></el-input>
        </div>
        <span slot="footer">
          <el-button @click="addDio = false">取 消</el-button>
          <el-button type="primary" @click="nextStep">下一步</el-button>
        </span>
      </template>
      <template v-else-if="addform.addStep == 2">
        <div class="contDio minH300">
          <div class="tips tc">
            <p>选择预约包含的门禁设备</p>
            <p>用户预约成功后，将获得这些门禁的使用权限</p>
          </div>
          <div class="tit flex">
            <div>授权设备：</div>
            <div class="col6">已选择：{{ addform.device_id.length }}项</div>
          </div>
          <div class="authUserList flex">
            <div class="userTree">
              <div class="titSub">空间列表</div>
              <el-tree
                ref="tree"
                class="defineTree"
                :data="spaceList"
                highlight-current
                default-expand-all
                node-key="space_id"
                :expand-on-click-node="false"
                :props="treeProps"
                @node-click="getNode"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <i
                    class="defineIcon"
                    :class="{
                      'el-icon-plus': !node.expanded,
                      'el-icon-minus': node.expanded,
                      opacity: node.childNodes.length === 0
                    }"
                  >
                  </i>
                  <span
                    class="label"
                    :class="
                      data.space_id === addform.space_id ? 'selectedTree' : ''
                    "
                    >{{ node.label }}</span
                  >
                </span>
              </el-tree>
            </div>
            <div class="checkList">
              <div class="titSub">设备列表</div>
              <div class="search">
                <el-input
                  size="small"
                  placeholder="请输入设备ID或设备名称"
                  prefix-icon="el-icon-search"
                  v-model="addform.search"
                  @input="searchInput"
                ></el-input>
                <div class="sizeDiv">
                  <p>门禁级别：</p>
                  <el-checkbox-group
                    v-model="addform.sizeCheck"
                    @change="
                      getSpaceDeviceYy(addform.space_id, addform.sizeCheck)
                    "
                  >
                    <el-checkbox label="A"></el-checkbox>
                    <el-checkbox label="B"></el-checkbox>
                    <el-checkbox label="C"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              <el-checkbox
                class="dblock"
                :indeterminate="addform.isIndeterminate"
                v-model="addform.checkAll"
                @change="CheckAllChange"
                >全选</el-checkbox
              >
              <el-checkbox-group
                class="groupH"
                v-model="addform.device_id"
                @change="CheckedItemChange"
              >
                <el-checkbox
                  class="dblock"
                  v-for="(item, index) in deviceList"
                  :label="item.device_no_id"
                  :key="index"
                  >{{ item.device_no_id }}-{{ item.device_name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="prevStep">上一步</el-button>
          <el-button type="primary" @click="nextStep">下一步</el-button>
        </span>
      </template>
      <template v-else>
        <div class="contDio minH300">
          <div class="tips tc">
            <p>设置审批人，则用户提交预约后</p>
            <p>需要审批人通过后再由被访人通过</p>
            <p>或在后台通过审批方可获得授权</p>
          </div>
          <el-checkbox
            v-model="addform.isCheck"
            @change="
              addform.userName = '';
              addform.user_id = '';
            "
            >设置审批人（如不勾选则只需被访人审批）</el-checkbox
          >
          <div class="tit flex">
            <div>设置审批人：{{ addform.userName }}</div>
          </div>
          <div class="authUserList flex" v-if="addform.isCheck">
            <div class="userTree">
              <div class="titSub">部门列表</div>
              <el-tree
                ref="tree"
                class="defineTree"
                :data="deparList"
                highlight-current
                default-expand-all
                node-key="id"
                :expand-on-click-node="false"
                :props="selectProps"
                @node-click="getNode2"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <i
                    class="defineIcon"
                    :class="{
                      'el-icon-plus': !node.expanded,
                      'el-icon-minus': node.expanded,
                      opacity: node.childNodes.length === 0
                    }"
                  >
                  </i>
                  <span
                    class="label"
                    :class="data.id === addform.depart_id ? 'selectedTree' : ''"
                    >{{ node.label }}</span
                  >
                </span>
              </el-tree>
            </div>
            <div class="checkList">
              <div class="titSub">人员列表</div>
              <div class="search pdtb6">
                <el-input
                  size="small"
                  placeholder="请输入姓名或手机号码"
                  prefix-icon="el-icon-search"
                  v-model="addform.search2"
                  @input="searchUser"
                ></el-input>
              </div>
              <el-radio-group
                class="groupH"
                v-model="addform.user_id"
                @change="getuserName"
              >
                <el-radio
                  class="dblock"
                  v-for="(item, index) in auditorList"
                  :label="item.user_id"
                  :key="index"
                  >{{ item.user_name }}-{{ item.phone_no }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="prevStep">上一步</el-button>
          <el-button type="primary" @click="submitConfig()">保存项目</el-button>
        </span>
      </template>
    </el-dialog>

    <!--修改弹窗-->
    <el-dialog
      title="修改门禁预约"
      :visible.sync="editDio"
      width="700px"
      class="configDio accessDio"
      center
    >
      <div class="step">
        <div class="item" :class="{ activeStep: editform.addStep == 1 }">
          1、编辑名称
        </div>
        <div class="item" :class="{ activeStep: editform.addStep == 2 }">
          2、选择设备
        </div>
        <div class="item" :class="{ activeStep: editform.addStep == 3 }">
          3、设置审批
        </div>
      </div>
      <template v-if="editform.addStep == 1">
        <div class="contDio minH300">
          <div class="tips tc">
            <p>为新建项目命名</p>
            <p>以根据名称区别不同的门禁预约项目</p>
          </div>
          <el-input
            placeholder="请输入项目名称"
            v-model="editform.projectName"
          ></el-input>
        </div>
        <span slot="footer">
          <el-button @click="addDio = false">取 消</el-button>
          <el-button type="primary" @click="nextStep">下一步</el-button>
        </span>
      </template>
      <template v-else-if="editform.addStep == 2">
        <div class="contDio minH300">
          <div class="tips tc">
            <p>选择预约包含的门禁设备</p>
            <p>用户预约成功后，将获得这些门禁的使用权限</p>
          </div>
          <div class="tit flex">
            <div>授权设备：</div>
            <div class="col6">已选择：{{ editform.device_id.length }}项</div>
          </div>
          <div class="authUserList flex">
            <div class="userTree">
              <div class="titSub">空间列表</div>
              <el-tree
                ref="tree"
                class="defineTree"
                :data="spaceList"
                highlight-current
                default-expand-all
                node-key="space_id"
                :expand-on-click-node="false"
                :props="treeProps"
                @node-click="getNode3"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <i
                    class="defineIcon"
                    :class="{
                      'el-icon-plus': !node.expanded,
                      'el-icon-minus': node.expanded,
                      opacity: node.childNodes.length === 0
                    }"
                  >
                  </i>
                  <span
                    class="label"
                    :class="
                      data.space_id === editform.space_id ? 'selectedTree' : ''
                    "
                    >{{ node.label }}</span
                  >
                </span>
              </el-tree>
            </div>
            <div class="checkList">
              <div class="titSub">设备列表</div>
              <div class="search">
                <el-input
                  size="small"
                  placeholder="请输入设备ID或设备名称"
                  prefix-icon="el-icon-search"
                  v-model="editform.search"
                  @input="searchInput2"
                ></el-input>
                <div class="sizeDiv">
                  <p>门禁级别：</p>
                  <el-checkbox-group
                    v-model="editform.sizeCheck"
                    @change="
                      getSpaceDeviceYy(editform.space_id, editform.sizeCheck)
                    "
                  >
                    <el-checkbox label="A"></el-checkbox>
                    <el-checkbox label="B"></el-checkbox>
                    <el-checkbox label="C"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              <el-checkbox
                class="dblock"
                :indeterminate="editform.isIndeterminate"
                v-model="editform.checkAll"
                @change="CheckAllChange2"
                >全选</el-checkbox
              >
              <el-checkbox-group
                class="groupH"
                v-model="editform.device_id"
                @change="CheckedItemChange2"
              >
                <el-checkbox
                  class="dblock"
                  v-for="(item, index) in deviceList"
                  :label="item.device_no_id"
                  :key="index"
                  >{{ item.device_no_id }}-{{ item.device_name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="prevStep">上一步</el-button>
          <el-button type="primary" @click="nextStep">下一步</el-button>
        </span>
      </template>
      <template v-else>
        <div class="contDio minH300">
          <div class="tips tc">
            <p>设置审批人，则用户提交预约后</p>
            <p>需要审批人通过后再由被访人通过</p>
            <p>或在后台通过审批方可获得授权</p>
          </div>
          <el-checkbox
            v-model="editform.isCheck"
            @change="
              editform.userName = '';
              editform.user_id = '';
            "
            >设置审批人（如不勾选则只需被访人审批）</el-checkbox
          >
          <div class="tit flex">
            <div>设置审批人：{{ editform.userName }}</div>
          </div>
          <div class="authUserList flex" v-if="editform.isCheck">
            <div class="userTree">
              <div class="titSub">部门列表</div>
              <el-tree
                class="defineTree"
                :data="deparList"
                highlight-current
                default-expand-all
                node-key="id"
                :expand-on-click-node="false"
                :props="selectProps"
                @node-click="getNode4"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <i
                    class="defineIcon"
                    :class="{
                      'el-icon-plus': !node.expanded,
                      'el-icon-minus': node.expanded,
                      opacity: node.childNodes.length === 0
                    }"
                  >
                  </i>
                  <span
                    class="label"
                    :class="
                      data.id === editform.depart_id ? 'selectedTree' : ''
                    "
                    >{{ data.name }}</span
                  >
                </span>
              </el-tree>
            </div>
            <div class="checkList">
              <div class="titSub">人员列表</div>
              <div class="search pdtb6">
                <el-input
                  size="small"
                  placeholder="请输入姓名或手机号码"
                  prefix-icon="el-icon-search"
                  v-model="editform.search2"
                  @input="searchUser2"
                ></el-input>
              </div>
              <el-radio-group
                class="groupH"
                v-model="editform.user_id"
                @change="getuserName2"
              >
                <el-radio
                  class="dblock"
                  v-for="(item, index) in auditorList"
                  :label="item.user_id"
                  :key="index"
                  >{{ item.user_name }}-{{ item.phone_no }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="prevStep">上一步</el-button>
          <el-button type="primary" @click="submitConfig(editform.id)"
            >保存项目</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!--查看包含设备-->
    <el-dialog title="包含设备" :visible.sync="accessDeviceDio" width="700px">
      <div class="contDio">
        <div class="tabList">
          <el-table :data="accessDevice" style="width: 100%">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column
              label="设备ID"
              prop="device_no_id"
            ></el-table-column>
            <el-table-column
              label="设备名称"
              prop="device_name"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <!--预览二维码-->
    <el-dialog
      title=""
      :visible.sync="previewDio"
      class="previewDio"
      width="550px"
    >
      <div class="tc"><h2>{{ dioAuditName }}</h2></div>
      <div class="tr"><el-button v-print="'#ewm'">打印</el-button></div>
      <div class="img" id="ewm"><img :src="dioImageUrl" alt="" /></div>
    </el-dialog>

    <!--删除配置-->
    <el-dialog title="" :visible.sync="statusDio" class="statusDio">
      <div class="statusCont">
        <div>是否删除该配置？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusDio = false">取 消</el-button>
        <el-button type="primary" @click="delConfig">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CBreadCrumb from "../Layout/CBreadCrumb.vue";
import {
  showToast,
  updataBreadCrumb
} from "../../../../static/js/utility/utility.js";
import {
  unmanApi,
  eSiteApi,
  sceneApi,
  bussinessApi,
  userApi
} from "../../../../static/js/api.js";

export default {
  name: "CAccessConfig",
  components: {
    CBreadCrumb
  },
  data() {
    return {
      configList: [], //配置列表
      tableLoading: false,
      //分页
      curr: 1, //当前页
      page: 10, //显示个数
      total: 0, //总数据

      addDio: false, //新建弹窗
      addform: {
        addStep: 1, //步骤
        projectName: "", //项目名称
        isIndeterminate: false, //全选状态
        checkAll: false, //是否全选
        space_id: "", //当前空间id
        sizeCheck: ["A", "B", "C"], //门禁大小
        search: "", //设备搜索
        device_id: [],
        search2: "", //用户搜索
        userName: "", //审批人
        user_id: "", //选中的用户
        depart_id: "", //部门当前选中
        isCheck: false //默认不勾选
      },

      editDio: false, //修改弹窗
      editform: {
        id: "", //修改的配置ID
        addStep: 1, //步骤
        projectName: "", //项目名称
        isIndeterminate: false, //全选状态
        checkAll: false, //是否全选
        space_id: "", //当前空间id
        sizeCheck: ["A", "B", "C"], //门禁大小
        search: "", //设备搜索
        device_id: [],
        search2: "", //用户搜索
        userName: "", //审批人
        user_id: "", //选中的用户
        depart_id: "", //部门当前选中
        isCheck: false //默认不勾选
      },

      spaceList: [], //空间列表
      deviceList: [], //设备列表

      allDevice: [], //所有设备
      allUser: [], //所有用户

      deparList: [], //部门列表
      auditorList: [], //用户列表

      selectProps: {
        label: "name",
        id: "id",
        children: "children"
      },
      treeProps: {
        label: "space_name",
        id: "space_id",
        children: "children"
      },

      //查看包含设备
      accessDeviceDio: false,
      accessDevice: [],

      previewDio: false, //预览二维码
      dioImageUrl: "", //二维码地址
      //二维码弹窗-项目名称
      dioAuditName: "",

      //删除配置
      statusDio: false,
      del_id: ""
    };
  },
  mounted() {},
  created: async function() {
    this.getMjConfig();
    this.getSpaceList();
    this.getDepartmentList();
  },
  methods: {
    //打开修改配置弹窗
    openEdit(index) {
      if (this.configList[index].user_id != "") {
        this.editform.isCheck = true;
      }
      let space_id = (this.editform.space_id = this.spaceList[0].space_id);
      let depart_id = (this.editform.depart_id = this.deparList[0].id);
      this.editform.id = this.configList[index].id;
      this.editform.projectName = this.configList[index].audit_name;
      this.editform.user_id = this.configList[index].user_id;
      this.editform.userName = this.configList[index].user_name;
      var arr = [];
      for (var i in this.configList[index].device_info) {
        arr.push(this.configList[index].device_info[i].device_no_id);
      }
      this.editform.device_id = arr;
      this.getSpaceDeviceYy(space_id, this.editform.sizeCheck);
      this.getUserYy(depart_id, "2");
      this.editDio = true;
    },
    //打开删除弹窗
    openStatus(id) {
      this.del_id = id;
      this.statusDio = true;
    },
    //删除配置
    async delConfig() {
      let that = this;
      let data = {
        id: that.del_id //授权用户id
      };
      let res = await bussinessApi.delYuyueConfig(data);
      if (res.meta.code === 200) {
        that.getMjConfig(1);
        that.statusDio = false;
        showToast("删除成功！");
      } else {
        showToast(res.meta.message);
      }
    },

    //查看预约二维码
    previewImg(img) {
      this.dioImageUrl = img;
      this.previewDio = true;
    },

    previewImgByIndex(index) {
      let audit = this.configList[index];
      this.dioImageUrl = audit.Qrcode;
      this.dioAuditName = audit.audit_name;
      console.log(this.dioAuditName)
      this.previewDio = true;
    },

    //点击查看包含设备
    getAccessDevice(data) {
      this.accessDevice = data;
      this.accessDeviceDio = true;
    },
    //上一步
    prevStep() {
      let that = this;
      if (this.addDio == true) {
        if (that.addform.addStep == 3) {
          that.addform.addStep = 2;
        } else if (that.addform.addStep == 2) {
          that.addform.addStep = 1;
        }
      } else if (this.editDio == true) {
        if (that.editform.addStep == 3) {
          that.editform.addStep = 2;
        } else if (that.editform.addStep == 2) {
          that.editform.addStep = 1;
        }
      }
    },
    //下一步
    nextStep() {
      let that = this;
      if (this.addDio == true) {
        if (that.addform.addStep == 1) {
          if (that.addform.projectName == "") {
            showToast("请输入项目名称");
            return;
          } else if (that.addform.projectName.length > 20) {
            showToast("项目名称不能大于20位");
            return;
          }
          that.addform.addStep = 2;
        } else if (that.addform.addStep == 2) {
          if (that.addform.device_id == "") {
            showToast("请选择门禁设备");
            return;
          }
          that.addform.addStep = 3;
        }
      } else if (this.editDio == true) {
        if (that.editform.addStep == 1) {
          if (that.editform.projectName == "") {
            showToast("请输入项目名称");
            return;
          } else if (that.editform.projectName.length > 20) {
            showToast("项目名称不能大于20位");
            return;
          }
          that.editform.addStep = 2;
        } else if (that.editform.addStep == 2) {
          if (that.editform.device_id == "") {
            showToast("请选择门禁设备");
            return;
          }
          that.editform.addStep = 3;
        }
      }
    },
    //提交配置
    async submitConfig(id) {
      let that = this;
      if (id) {
        var dataObj = {
          id: id,
          audit_name: that.editform.projectName,
          user_id: that.editform.user_id,
          device_no_id: that.editform.device_id,
          code_type: "1" //1为门禁，2为会议室，默认1
        };
        var res = await bussinessApi.updateAppintmentAuditor(dataObj);
      } else {
        var dataObj = {
          audit_name: that.addform.projectName, //预约名称
          device_no_id: that.addform.device_id, //设备组
          code_type: "1" //1为门禁，2为会议室，默认1
        };
        if (that.addform.isCheck == true) {
          if (that.addform.user_id == "") {
            showToast("请选择审批人");
            return;
          }
          dataObj.user_id = that.addform.user_id;
        }
        var res = await bussinessApi.configYuyue(dataObj);
      }
      if (res.meta.code == 200) {
        if (!id) {
          that.addform = {
            addStep: 1, //步骤
            projectName: "", //项目名称
            isIndeterminate: false, //全选状态
            checkAll: false, //是否全选
            space_id: "", //当前空间id
            sizeCheck: ["A", "B", "C"], //门禁大小
            search: "", //设备搜索
            device_id: [],
            search2: "", //用户搜索
            userName: "", //审批人
            user_id: "", //选中的用户
            depart_id: "", //部门当前选中
            isCheck: false //默认不勾选
          };
          that.deviceList = [];
          that.auditorList = [];
          that.addDio = false;
          that.getMjConfig(1);
          showToast("配置成功！");
        } else {
          that.editform.addStep = 1;
          that.editDio = false;
          that.getMjConfig();
          showToast("修改成功！");
        }
      } else {
        showToast(res.meta.message);
      }
    },
    //获取空间列表
    async getSpaceList() {
      let that = this;
      let res = await sceneApi.space();
      if (res.meta.code === 200) {
        that.spaceList = [...res.data];
        // that.processScene(res.data) // 汕头移动需注释
      } else {
        showToast(res.meta.message);
      }
    },
    // 处理位置数据
    processScene(data) {
      let that = this;
      if (data.length !== 0) {
        // 显示某个公司或其下级空间的设备列表
        let list = data;
        // 获取所属位置列表
        for (let s in list) {
          let area = list[s].children;
          for (let i in area) {
            let street = area[i].children;
            for (let j in street) {
              let company = street[j];
              that.spaceList.push(company);
            }
          }
        }
      }
    },
    //通过空间id获取预约的设备列表
    async getSpaceDeviceYy(space_id, size) {
      let that = this;
      const data = {
        space_id: space_id,
        level_type: size.join(","),
        // 'code':'ACCESS',
        code_type: "1" //1门禁，2会议室，默认1
      };
      const res = await bussinessApi.getSpaceDeviceYy(data);
      if (res.meta.code == 200) {
        that.allDevice = res.data;
        that.deviceList = res.data;
      } else {
        showToast(res.meta.message);
      }
    },
    // 获取部门列表
    async getDepartmentList() {
      console.log("4848", "");
      let that = this;
      const res = await userApi.getDepartmentList();
      if (res.meta.code === 200) {
        that.deparList = res.data;
        // console.log("deparList", that.deparList);
      } else {
        showToast(res.meta.message);
      }
    },
    //通过部门获取审批人
    async getUserYy(depart_id, type) {
      let that = this;
      const data = {
        perPage: 99999,
        department_id: depart_id
      };
      const res = await userApi.getUserList(data);
      if (res.meta.code === 200) {
        that.allUser = res.data.list;
        // that.auditorList = res.data.list
        if (type == "1") {
          that.searchUser();
        } else if (type == "2") {
          that.searchUser2();
        }
      } else {
        showToast(res.meta.message);
      }
    },
    //搜索筛选
    searchUser() {
      let that = this;
      var allUser = this.allUser;
      var searchList = [];
      for (var i in allUser) {
        if (that.addform.search2 != "") {
          if (
            allUser[i].user_name.indexOf(that.addform.search2) != -1 ||
            allUser[i].phone_no.indexOf(that.addform.search2) != -1
          ) {
            searchList.push(allUser[i]);
          }
        } else {
          searchList = allUser;
        }
      }
      // console.log('searchList',searchList)
      this.auditorList = searchList;
    },
    //同步当前选中的审批人
    getuserName(val) {
      this.addform.userName = this.auditorList.find(
        item => item.user_id === val
      )["user_name"];
    },
    //获取树形节点(添加)
    getNode2(node) {
      let that = this;
      this.addform.depart_id = node.id;
      //调用获取用户的接口
      this.getUserYy(node.id, "1");
      // this.getSpaceDeviceSmzf(this.addform.type,'1',node.id)
    },
    //搜索筛选
    searchInput() {
      let that = this;
      var allDevice = this.allDevice;
      var searchList = [];
      for (var i in allDevice) {
        if (that.addform.search != "") {
          if (
            allDevice[i].device_name.indexOf(that.addform.search) != -1 ||
            allDevice[i].device_no_id.indexOf(that.addform.search) != -1
          ) {
            searchList.push(allDevice[i]);
          }
        } else {
          searchList = allDevice;
        }
      }
      // console.log('searchList',searchList)
      this.deviceList = searchList;
    },
    //全选(添加)
    CheckAllChange(val) {
      var arr = [];
      for (var i in this.deviceList) {
        arr.push(this.deviceList[i].device_no_id);
      }
      arr = Array.from(new Set(arr));
      this.addform.device_id = val ? arr : [];
      this.addform.isIndeterminate = false;
    },
    //选择多个(添加)
    CheckedItemChange(value) {
      let checkedCount = value.length;
      this.addform.checkAll = checkedCount === this.deviceList.length;
      this.addform.isIndeterminate =
        checkedCount > 0 && checkedCount < this.deviceList.length;
    },
    //获取树形节点(添加)
    getNode(node) {
      let that = this;
      this.addform.space_id = node.space_id;
      //调用获取设备列表的接口
      this.getSpaceDeviceYy(node.space_id, this.addform.sizeCheck);
      // this.getSpaceDeviceSmzf(this.addform.type,'1',node.space_id,this.addform.sizeCheck)
    },

    //搜索筛选
    searchUser2() {
      let that = this;
      var allUser = this.allUser;
      var searchList = [];
      for (var i in allUser) {
        if (that.editform.search2 != "") {
          if (
            allUser[i].user_name.indexOf(that.editform.search2) != -1 ||
            allUser[i].phone_no.indexOf(that.editform.search2) != -1
          ) {
            searchList.push(allUser[i]);
          }
        } else {
          searchList = allUser;
        }
      }
      // console.log('searchList',searchList)
      this.auditorList = searchList;
    },
    //同步当前选中的审批人
    getuserName2(val) {
      this.editform.userName = this.auditorList.find(
        item => item.user_id === val
      )["user_name"];
    },
    //获取树形节点(修改)
    getNode4(node) {
      let that = this;
      this.editform.depart_id = node.id;
      //调用获取用户的接口
      this.getUserYy(node.id, "2");
      // this.getSpaceDeviceSmzf(this.addform.type,'1',node.id)
    },
    //搜索筛选
    searchInput2() {
      let that = this;
      var allDevice = this.allDevice;
      var searchList = [];
      for (var i in allDevice) {
        if (that.editform.search != "") {
          if (
            allDevice[i].device_name.indexOf(that.editform.search) != -1 ||
            allDevice[i].device_no_id.indexOf(that.editform.search) != -1
          ) {
            searchList.push(allDevice[i]);
          }
        } else {
          searchList = allDevice;
        }
      }
      // console.log('searchList',searchList)
      this.deviceList = searchList;
    },
    //全选(添加)
    CheckAllChange2(val) {
      var arr = [];
      for (var i in this.deviceList) {
        arr.push(this.deviceList[i].device_no_id);
      }
      arr = Array.from(new Set(arr));
      this.editform.device_id = val ? arr : [];
      this.editform.isIndeterminate = false;
    },

    //选择多个(添加)
    CheckedItemChange2(value) {
      let checkedCount = value.length;
      this.editform.checkAll = checkedCount === this.deviceList.length;
      this.editform.isIndeterminate =
        checkedCount > 0 && checkedCount < this.deviceList.length;
    },

    //获取树形节点(添加)
    getNode3(node) {
      let that = this;
      this.editform.space_id = node.space_id;
      //调用获取设备列表的接口
      this.getSpaceDeviceYy(node.space_id, this.editform.sizeCheck);
      // this.getSpaceDeviceSmzf(this.addform.type,'1',node.space_id,this.addform.sizeCheck)
    },

    //打开新建弹窗
    openAdd() {
      let space_id = (this.addform.space_id = this.spaceList[0].space_id);
      let depart_id = (this.addform.depart_id = this.deparList[0].id);
      this.getSpaceDeviceYy(space_id, this.addform.sizeCheck);
      this.getUserYy(depart_id, "1");
      this.addDio = true;
    },
    //获取配置设置列表
    async getMjConfig(curr, limits) {
      let that = this;
      this.tableLoading = true;
      const data = {
        page: curr ? curr : that.curr, //当前页
        perPage: limits ? limits : that.page, //每页条数
        code_type: "1" //1门禁 2会议室
      };
      let res = await bussinessApi.auditorLiist(data);
      if (res.meta.code == 200) {
        that.configList = res.data.list;
        that.total = parseInt(res.data.total);
        that.tableLoading = false;
      } else {
        that.tableLoading = false;
        showToast(res.meta.message);
      }
    },
    //分页
    CurrentChange(val) {
      this.curr = val;
      this.getMjConfig(val);
    }
  },
  watch: {}
};
</script>

<style lang="scss">
.CAccessConfig {
  .tc {
    text-align: center;
  }
  .minH300 {
    min-height: 300px;
  }
  .accessDio {
    .titSub {
      height: 30px;
      padding: 0 10px;
      line-height: 30px;
      background: #e8e8e8;
      color: #333;
      box-sizing: border-box;
    }
    .tips {
      color: #999;
      padding: 15px 0;
    }
    .step {
      padding: 0;
      height: 30px;
      margin: 0 33px 0 18px;
      background: #dadada;
      border-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .item {
        width: 33.33%;
        font-size: 12px;
        color: #fff;
        line-height: 30px;
        text-align: center;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          right: -30px;
          top: 0;
          width: 0;
          height: 0;
          border-width: 15px;
          border-style: solid;
          border-color: transparent transparent transparent #dadada;
          z-index: 10;
        }
        &.activeStep {
          background: #4babfe;
          &::after {
            border-color: transparent transparent transparent #4babfe;
          }
        }
      }
    }
  }
  .configDio {
    .selectedTree {
      font-weight: bold;
    }
    .authUserList {
      border: 1px solid #979797;
      align-items: flex-start !important;
      .userTree {
        width: 44%;
        height: 330px;
        overflow-y: auto;
        border-right: 1px solid #979797;
        flex-shrink: 0;
      }
      .checkList {
        flex-grow: 1;
        .search {
          // text-align: center;
          padding: 6px 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-input {
            width: 50%;
            .el-input__inner {
              border-radius: 16px;
            }
          }
          .sizeDiv {
            margin-left: 10px;
            .el-checkbox {
              margin-right: 10px;
            }
          }
          &.pdtb6 {
            padding: 6px 0;
          }
        }
        .el-checkbox.dblock,
        .el-radio.dblock {
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          flex-direction: row-reverse;
          padding-right: 16px;
          .el-checkbox__label,
          .el-radio__label {
            padding-left: 16px;
          }
        }
        .el-checkbox-group.groupH {
          height: 227px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
        .el-radio-group.groupH {
          display: block;
          height: 256px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
      }
    }
    .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tit {
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
    .authUser {
      border: 1px solid #e4e7ed;
      align-items: flex-start;
      .userTree {
        width: 200px;
        border-right: 1px solid #e4e7ed;
        height: 300px;
        overflow-y: auto;
      }
      .checkList {
        flex: 1;
        height: 300px;
        overflow-y: auto;
        padding: 20px;
        .el-checkbox-group {
          display: flex;
          flex-wrap: wrap;
          .checkItem {
            width: 33.33%;
            .el-checkbox {
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              .el-checkbox__label {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
  .previewDio {
    .tr {
      text-align: right;
      el-button {
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img {
      width: 320px;
      width: 320px;
      margin: 0px auto;
      padding: 20px;
      img {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CAccess/CAccessConfig.vue